import { Link } from "react-router-dom";
import { useAppSelector } from "@common/store/hooks";
import Cover from "../../library/Cover";
import { SYSTEM_LABEL, systemOf, type System } from "../../library/localLibrary";
import { formatPlayed, playKey } from "../../library/playtime";
import { useDashboard, useMyPlaytime } from "../../library/queries";
import { displayName, romBaseName } from "../saves";

/**
 * The running game at a glance, under the pad on a phone: cover, name,
 * console, and (signed in) your time on it beside everyone's. Opens the
 * game's library page.
 */
export default function GameCard({ name, system }: { name: string; system?: string | null }) {
  const { isAuthenticated } = useAppSelector((s) => s.auth);
  const mine = useMyPlaytime(isAuthenticated).data?.find((g) => g.game === playKey(name));
  const everyone = useDashboard(isAuthenticated).data?.games.find((g) => g.game === playKey(name));
  const console = (system ?? systemOf(name)) as System;
  return (
    <Link to={`/library?${new URLSearchParams({ game: romBaseName(name) })}`} className="game-card">
      <Cover name={name} className="game-card-cover" />
      <span className="game-card-text">
        <strong>{displayName(name)}</strong>
        <span className="muted small">{SYSTEM_LABEL[console] ?? console}</span>
        {isAuthenticated && (
          <span className="muted small">
            {mine ? `You ${formatPlayed(mine.seconds)}` : "Not played yet"}
            {everyone && everyone.seconds > (mine?.seconds ?? 0) && ` · everyone ${formatPlayed(everyone.seconds)}`}
            {everyone && everyone.players.length > 1 && ` · ${everyone.players.length} players`}
          </span>
        )}
      </span>
    </Link>
  );
}
